var _circle, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCloseimage(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 7,
    cy: 7,
    r: 7,
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.15264 4.14639C4.05891 4.24016 4.00625 4.36731 4.00625 4.49989C4.00625 4.63248 4.05891 4.75963 4.15264 4.85339L5.92064 6.62139L4.15264 8.38939C4.10489 8.43552 4.0668 8.49069 4.04059 8.55169C4.01439 8.61269 4.0006 8.6783 4.00002 8.74469C3.99944 8.81108 4.01209 8.87692 4.03723 8.93837C4.06237 8.99982 4.0995 9.05564 4.14645 9.10259C4.19339 9.14954 4.24922 9.18666 4.31067 9.2118C4.37212 9.23694 4.43796 9.2496 4.50434 9.24902C4.57073 9.24844 4.63634 9.23465 4.69735 9.20844C4.75835 9.18224 4.81352 9.14415 4.85964 9.09639L6.62764 7.32839L8.39564 9.09639C8.48995 9.18747 8.61625 9.23787 8.74735 9.23673C8.87844 9.23559 9.00385 9.18301 9.09655 9.0903C9.18926 8.9976 9.24184 8.87219 9.24298 8.74109C9.24412 8.61 9.19372 8.48369 9.10265 8.38939L7.33464 6.62139L9.10265 4.85339C9.19372 4.75909 9.24412 4.63279 9.24298 4.50169C9.24184 4.37059 9.18926 4.24519 9.09655 4.15248C9.00385 4.05978 8.87844 4.0072 8.74735 4.00606C8.61625 4.00492 8.48995 4.05531 8.39564 4.14639L6.62764 5.91439L4.85964 4.14639C4.76588 4.05266 4.63873 4 4.50614 4C4.37356 4 4.24641 4.05266 4.15264 4.14639Z",
    fill: "#FF3B30"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCloseimage);
export default __webpack_public_path__ + "static/media/closeimage.25ee0a1120d7ada4fe2fc83348cf67da.svg";
export { ForwardRef as ReactComponent };